const CONSTANTS = {
  SET_LANGUAGE: "SET_LANGUAGE",
  SET_SIDEBAR_OPEN: "SET_SIDEBAR_OPEN",
  TOGGLE_SIDEBAR_OPEN: "TOGGLE_SIDEBAR_OPEN",
  RESET_COMMON: "RESET_COMMON",
  SET_API_CALL_EXECUTED: "SET_API_CALL_EXECUTED",
  ADD_ADDITIONAL_TRANSLATIONS: "ADD_ADDITIONAL_TRANSLATIONS",
  MODULE_LOADED: "MODULE_LOADED",

  SET_APPLICATION_DARK_MODE: "SET_APPLICATION_DARK_MODE",
};

export default CONSTANTS;
